import React, { createContext, useState } from "react";

const BANK_CONCILIATION_CONTEXT_STATE = {
  tabSelected: "0",
  handleTabClick: (key) => {},
};

export const BankConciliationContext = createContext(
  BANK_CONCILIATION_CONTEXT_STATE
);

export const BankConciliationProvider = ({ children }) => {
  const [tabSelected, setTabSelected] = useState(
    BANK_CONCILIATION_CONTEXT_STATE.tabSelected
  );
  const handleTabClick = (key) => {
    setTabSelected(key);
  };
  const values = {
    tabSelected,
    handleTabClick,
  };
  return (
    <BankConciliationContext.Provider value={values}>
      {children}
    </BankConciliationContext.Provider>
  );
};
